export default __webpack_public_path__ + "static/media/image-mejdi.3072a72c.jpg";